import { createActions, createReducer } from 'reduxsauce'

import ConsultaRemuneracaoADMRHService from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaCargosVagosOcupadosServidoresInicio: [],
    buscaConsultaCargosVagosOcupadosServidoresErro: ['erro'],
    buscaConsultaCargosVagosOcupadosServidoresSucesso: ['consultaCargosVagosOcupadosServidores'],
    limpar: [],
    setConsultaCargosVagosOcupadosServidoresEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.consultarQuadrosServidores = (filtro, tipoServidor) => {
    return dispatch => {
        dispatch(Creators.buscaConsultaCargosVagosOcupadosServidoresInicio())
        let serv = new ConsultaRemuneracaoADMRHService()
        return serv
            .consultarCargosVagosOcupadosMembros(filtro, tipoServidor)
            .then(response => dispatch(Creators.buscaConsultaCargosVagosOcupadosServidoresSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaCargosVagosOcupadosServidoresErro(error)))
    }
}

const buscaConsultaCargosVagosOcupadosServidoresInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaCargosVagosOcupadosServidoresErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaCargosVagosOcupadosServidoresSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaCargosVagosOcupadosServidores.resultado,
        dataSincronizacaoDados: action.consultaCargosVagosOcupadosServidores.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaCargosVagosOcupadosServidoresEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_CARGOS_VAGOS_OCUPADOS_SERVIDORES_INICIO]: buscaConsultaCargosVagosOcupadosServidoresInicio,
    [Types.BUSCA_CONSULTA_CARGOS_VAGOS_OCUPADOS_SERVIDORES_ERRO]: buscaConsultaCargosVagosOcupadosServidoresErro,
    [Types.BUSCA_CONSULTA_CARGOS_VAGOS_OCUPADOS_SERVIDORES_SUCESSO]: buscaConsultaCargosVagosOcupadosServidoresSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_CARGOS_VAGOS_OCUPADOS_SERVIDORES_ESTADO_DT]: setConsultaCargosVagosOcupadosServidoresEstadoDT,
})
